import React from 'react';
import PropTypes from 'prop-types';

import { FormContext, useForm } from 'react-hook-form';
import { Button } from '.';

/**
* Popup
* 
* @param {Object}    props
* @param {string}    props.title           - The main title
* @param {string}    props.text            - The description
* @param {boolean}   props.isOpen          - Flag thats opens/closes the popup
* @param {Function}  props.onSubmit        - Handles when the popup is submitted
* @param {Object}    props.children        - Child components
* @param {Object}    props.primaryButton   - Primary button
* @param {Object}    props.secondaryButton - Secondary button
*/
const Popup = ({ title, text, isOpen, onSubmit, children, primaryButton, secondaryButton }) => {
  const methods = useForm({ reValidateMode: 'onSubmit' });
  return (
    <aside className={'popup ' + ((isOpen) ? 'popup--open' : '')}>
      <FormContext {...methods} >
        <form className='popup__container' onSubmit={methods.handleSubmit(onSubmit)}>
          <h1 className='popup__title'> {title}
          </h1>
          {text && <p className='popup__text' dangerouslySetInnerHTML={{ __html: text }} />}
          {children}
          <div className='page__footer '>
            {secondaryButton && <Button {...secondaryButton} />}
            {primaryButton && <Button {...primaryButton} />}
          </div>
        </form>
      </FormContext>
    </aside>
  );
}
Popup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  onSubmit: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.bool
  ]),
  primaryButton: PropTypes.object,
  secondaryButton: PropTypes.object,
};
export default Popup;